import { Navigate } from 'react-router-dom';
import Navigation from "./Navigation.jsx";
import { useParams } from "react-router";
import ResidentProfile from "./profile-templates/Resident.jsx";
import AreaProfile from "./profile-templates/Area.jsx";
import {iAmHigherAuthority} from "../libs.jsx";
import ServerProfile from "./profile-templates/Server.jsx";
import CorporateProfile from "./profile-templates/Corporation.jsx";
import CampusProfile from "./profile-templates/Campus.jsx";
import InovonicsDevice from "./profile-templates/InovonicsDevice.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import AccutechDevice from "./profile-templates/AccutechDevice.jsx";
import CampusUploadPreview from "./CampusUploadPreview.jsx";
import CampusUploadPreviewPage from "../pages/customers/campuses/campus-upload-preview/CampusUploadPreviewPage.jsx";
import UserProfile from "./profile-templates/User.jsx";
import Event from "./profile-templates/Event.jsx";
import PalcareDevice from "./profile-templates/PalcareDevice.jsx";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import ServerProfilePage from "../pages/servers/profile/ServerProfilePage.jsx";
import DeviceProfilePage from "../pages/devices/device-profile/DeviceProfilePage.jsx";
import AreaProfilePage from "../pages/community/areas/area-profile/AreaProfilePage.jsx";
import ResidentProfilePage from "../pages/community/residents/resident-profile/ResidentProfilePage.jsx";
import UserProfilePage from "../pages/users/user-profile/UserProfilePage.jsx";
import CorporateProfilePage from "../pages/customers/corporations/corporate-profile/CorporateProfilePage.jsx";
import CampusProfilePage from "../pages/customers/campuses/campus-profile/CampusProfilePage.jsx";
import EventProfilePage from "../pages/events/event-profile/EventProfilePage.jsx";
import { getSession } from "../services/session";

const Profiles = (props) => {
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';
    let pageContent, dData, paramVars, bData;
    paramVars = useParams();

    dData = getSession();

    if (paramVars.dType === "resident" && iAmHigherAuthority(10, dData?.role_weight)){
        pageContent = isV2
            ? <ResidentProfilePage id={paramVars?.eType} />
            : <ResidentProfile id={paramVars?.eType} />;
    }
    else if (paramVars.dType === "area" && iAmHigherAuthority(10, dData?.role_weight)){
        pageContent = isV2 ? <AreaProfilePage id={paramVars?.eType} /> : <AreaProfile id={paramVars?.eType} />;
    }
    else if (paramVars.dType === "inovonics" && iAmHigherAuthority(10, dData?.role_weight)){
        pageContent = isV2 ? <DeviceProfilePage id={paramVars?.eType} mfgId="1" /> : <InovonicsDevice id={paramVars?.eType} />;
    }
    else if (paramVars.dType === "palcare" && iAmHigherAuthority(10, dData?.role_weight)){
        pageContent = isV2 ? <DeviceProfilePage id={paramVars?.eType} mfgId="4" /> : <PalcareDevice id={paramVars?.eType} />;
    }
    else if (paramVars.dType === "accutech" && iAmHigherAuthority(10, dData?.role_weight)){
        pageContent = <AccutechDevice id={paramVars?.eType} />;
    }
    else if (paramVars.dType === "user" && iAmHigherAuthority(10, dData?.role_weight)){
        pageContent = isV2 ? <UserProfilePage id={paramVars?.eType} /> : <UserProfile id={paramVars?.eType} />;
    }
    else if (paramVars.dType === "server" && iAmHigherAuthority(99, dData?.my_role_weight)){
        pageContent = isV2 ? <ServerProfilePage id={paramVars?.eType} /> : <ServerProfile id={paramVars?.eType} />;
    }
    else if (paramVars.dType === "corporate" && iAmHigherAuthority(99, dData?.my_role_weight)){
        pageContent = isV2
            ? <CorporateProfilePage id={paramVars?.eType} />
            : <CorporateProfile id={paramVars?.eType} />;
    }
    else if (paramVars.dType === "event" && iAmHigherAuthority(10, dData?.role_weight)){
        pageContent = isV2
            ? <EventProfilePage id={paramVars?.eType} />
            : <Event id={paramVars?.eType} />;
    }
    else if (paramVars.dType === "campus" && iAmHigherAuthority(99, dData?.my_role_weight)){
        if (paramVars?.kType !== undefined){
            pageContent = isV2
                ? <CampusUploadPreviewPage campusId={paramVars?.eType} uploadKey={paramVars?.kType} />
                : <CampusUploadPreview campus_id={paramVars?.eType} id={paramVars?.kType} />;
        }else{
            pageContent = isV2
                ? <CampusProfilePage id={paramVars?.eType} />
                : <CampusProfile id={paramVars?.eType} />;
        }
    }
    else{
        pageContent = (
            <div>
                <h3>Page not found. 404</h3>
            </div>
        );
    }

    return iAmHigherAuthority(10, dData?.role_weight) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {pageContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Profiles;